export default "__VITE_ASSET__BDOcYVPI__"